import { useMemo, useState } from "react";
import PageLayout from "../components/PageLayout";

const TOKEN_STORAGE_KEY = "checkride.admin.jwt";

const AdminPage = () => {
  const [status, setStatus] = useState<string | null>(null);
  const savedToken = useMemo(() => localStorage.getItem(TOKEN_STORAGE_KEY), []);

  const handleSignOut = () => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    setStatus("Token cleared.");
    window.location.hash = "#/admin/sign_in";
  };

  return (
    <PageLayout route="admin">
      <section className="panel panel-tight">
        <h2>Admin</h2>
        <p>Select a tool below.</p>
        {savedToken ? (
          <div className="admin-tools">
            <ul className="admin-tools-list">
              <li className="admin-tool-item">
                <a className="admin-tool-link" href="#/admin/metadata">
                  <span className="admin-tool-title">Manage Metadata</span>
                  <span className="admin-tool-meta">Units, weapons, airdromes</span>
                </a>
              </li>
              <li className="admin-tool-item">
                <a className="admin-tool-link" href="#/admin/pilot_state">
                  <span className="admin-tool-title">Live Pilot State</span>
                  <span className="admin-tool-meta">Realtime state stream from ingested events</span>
                </a>
              </li>
              <li className="admin-tool-item is-disabled">
                <span className="admin-tool-title">Manage Servers</span>
                <span className="admin-tool-meta">Coming Soon</span>
              </li>
            </ul>
            <div className="form-actions">
              <button type="button" className="button-secondary" onClick={handleSignOut}>
                Sign out
              </button>
            </div>
          </div>
        ) : (
          <p className="status">No token found. Visit /admin/sign_in to authenticate.</p>
        )}
        {status && <p className="status">{status}</p>}
      </section>
    </PageLayout>
  );
};

export default AdminPage;
